import { useLayoutEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  ["/", "Home"],
  ["/about", "About"],
  ["/services", "Services"],
  ["/projects", "Projects"],
  ["/contact", "Contact"],
];

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useLayoutEffect(() => setOpen(false), [pathname, setOpen]);

  return (
    <header className="site-header" data-testid="site-header">
      <div className="nav-shell">
        <Link to="/" className="brand" data-testid="header-logo-link" aria-label="NCP Mechanical home">
          <img className="brand-logo" src="/ncp-mechanical-logo.png" alt="NCP Mechanical Ltd" data-testid="header-logo-image" />
        </Link>

        <nav className="desktop-nav" data-testid="desktop-navigation" aria-label="Main navigation">
          {links.map(([to, label]) => (
            <NavLink key={to} to={to} data-testid={`header-${label.toLowerCase()}-link`}>
              {label}
            </NavLink>
          ))}
        </nav>

        <Link to="/contact" className="nav-cta" data-testid="header-enquiry-link">Let’s talk</Link>
        <button
          className="menu-button"
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-label="Toggle navigation"
          data-testid="mobile-menu-button"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <nav className="mobile-nav" data-testid="mobile-navigation" aria-label="Mobile navigation">
          {links.map(([to, label]) => (
            <NavLink key={to} to={to} data-testid={`mobile-${label.toLowerCase()}-link`}>
              {label}<span>0{links.findIndex((item) => item[0] === to) + 1}</span>
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};